import { BaseService } from "./../base";
export class PatientService extends BaseService {
  emailTm = "laboratorio@redsalud.gov.cl";
  passwordTm = "secret";

  static get entity() {
    return "patient";
  }
  static get name() {
    return "patient";
  }
  static async getModalPatient() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/modal_patient`, "response");
  }
  static async getTokenHCM() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/recuperarToken`, "access_token");
  }
  static async getTokenSamples() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/get_token_tomamuestra/${this.emailTm}/${this.passwordTm}`, "token");
  }
  static async getByRut(rut) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/findbyrut/${rut}`, this.name);
  }
  /**
   *
   * @param {String} rut Rut del paciente sin separación con coma ni con guión
   * @param {String} access_token Token del hospital para usar Integración
   * @returns
   */
  static async getFilterByDocumentIntegration(rut, access_token) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter_by_document/${rut}/${access_token}/1`);
  }
  static async createPatient(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}`, null, data);
  }
  /**
   * Cambia el número de ubicación interna del paciente
   * @param {int} patient_id es el id del paciente al cual se le cambiará el número de ubicación interna
   * @param {int} file_number corresponde al nuevo número de ubicación interna
   * @returns
   */
  static async updateFileNumber(patient_id, data) {
    let asd;
    if (window.localStorage.getItem("stablishment") === "1803") {
      asd = "update_file_hae";
    } else {
      asd = "update_file_number";
    }
    let dataRequest =
      window.localStorage.getItem("stablishment") === "1803"
        ? {
            file_number_hae: data.file_number,
          }
        : {
            file_number: data.file_number,
          };
    return this.submit("put", `${this.getApiUrlEntity(this.profile)}${this.entity}/${asd}/${patient_id}`, this.name, dataRequest);
  }
  /**
   * Entrega un arreglo con los pacientes que tienen cierto número de ubicación interna
   * @param {int} file_number numero de ubicación interna del paciente
   * @returns
   */
  static async getByFileNumber(file_number) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/findby_filenumber/${file_number}`, this.name);
  }

  /**
   * Entrega un arreglo con los pacientes que tienen cierto número de ubicación interna
   * @param {int} file_number numero de ubicación interna del paciente
   * @returns
   */
  static async updateAttachedState(patient_id, data) {
    return this.submit("put", `${this.getApiUrlEntity(this.profile)}${this.entity}/update_attached_state/${patient_id}`, this.name, data);
  }

  /**
   * Busca Paciente por passaporte
   * @param {String} passaport
   * @returns
   */
  static async getByPassaport(passaport) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/findbypassport/${passaport}`, this.name);
  }

  /**
   * Busca paciente a traves de otra identificación
   * @param {String} otherIdentification
   * @returns
   */
  static async getByOtherIdentification(otherIdentification) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_other_indentification/${otherIdentification}`, this.name);
  }

  /**
   * Busca paciente a traves de rut provisorio
   * @param {String} otherIdentification
   * @returns
   */
  static async getByProvisionalRut(provisional_rut) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_provisional_rut/${provisional_rut}`, this.name);
  }

  /**
   * Busca paciente desde el rut materno
   * @param {String} motherRut
   * @returns
   */
  static async getByMotherRut(motherRut) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/findbymother_rut/${motherRut}`, this.name);
  }

  static async getPendingFile(pending) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_pending_file/${pending}`);
  }

  /**
   *
   * @param {String} rut Rut del paciente sin separación con coma ni con guión
   * @param {String} access_token Token del hospital para usar Integración
   * @returns
   */
  static async getUrlExams(rut) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/patient_exam_integration/${rut}`);
  }

  /**
   *  Integración con el clínico del sistema de urgencias
   *  http://10.6.180.236/ApiSSM/api/SSM/Urgencias
   * @param {String} rut Rut del paciente sin separación con punto y sin dígito verificador
   * @returns
   */
  static async getUrgencies(rut) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter_by_urgencies/${rut}`);
  }
  /**
   *  Integración con el clínico del sistema de urgencias
   *  http://10.6.180.236/ApiSSM/api/SSM/Urgencias
   * @param {String} rut Rut del paciente sin separación con punto y sin dígito verificador
   * @returns
   */
  static async filter_by_orders(rut) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter_by_orders/${rut}`, null);
  }
  static async filter_by_orders_pdf(idPeticion, date, type) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter_by_orders_pdf/${idPeticion}/${date}/${type}`, null, null, {
      responseType: "blob",
    });
  }
  static async filter_by_urgencias_pdf(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter_by_urgencies_pdf/${id}`, null, null, {
      responseType: "blob",
    });
  }
  /*
   *  http://10.6.180.236/ApiSSM/api/SSM/Hospitalizaciones
   * @param {String} rut Rut del paciente sin separación con punto y sin dígito verificador
   * @returns
   */
  static async getHospitalizations(rut) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter_by_hospitalizations/${rut}`);
  }

  /**
   *
   * @param {numbeer} patient_id Id del paciente
   * @param {Patient} data datos del paciente
   * @returns Se valida si los datos del paciente cumplen con los minimos solicitados
   */
  static async getPatientValidate(patient_id, data) {
    return this.submit("put", `${this.getApiUrlEntity(this.profile)}${this.entity}/patient_validate/${patient_id}`, null, data);
  }

  static async getMpiData(rut) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}mpi/search_patient/${rut}`, null);
  }

  static async getPatientAllData(patient_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/patient_get_all_data/${patient_id}`);
  }

  static async getMergePatient(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/merge_patient`, null, payload);
  }
}
